/**
 * @param {{ errors?: Record<string, string[]> }} props
 */
export function FieldErrors({ errors }) {
  if (!errors || typeof errors !== 'object') {
    return null;
  }
  const entries = Object.entries(errors).flatMap(([field, msgs]) =>
    (msgs || []).map((m) => ({ field, m })),
  );
  if (!entries.length) {
    return null;
  }
  return (
    <ul className="field-errors">
      {entries.map(({ field, m }) => (
        <li key={`${field}-${m}`}>
          <strong>{field}</strong>: {m}
        </li>
      ))}
    </ul>
  );
}
